import { useEffect, useState } from 'react';
import { Link } from 'react-router-dom';
import axios from 'axios';
import parse from 'html-react-parser';
import "./styles/articles.css";

function Articles({settingCurrentPageForHeader}) {

    useEffect(()=> {
        settingCurrentPageForHeader("articles");
    }, [settingCurrentPageForHeader]);

    const [articlesState, setArticlesState] = useState({
        content : null,
        pageContent : null,
        status : false
    });

    useEffect(() => {
        axios.get('/api/articles.json')
        .then(function (response) {
            setArticlesState({
                content : response.data.articles,
                pageContent : response.data.pageContent,
                status : true
            });
        })
        .catch(function (error) {
            setArticlesState({
                pageContent : null,
                content : <p className="text-center">Ups! Błąd aplikacji</p>,
                status : false
            });
        })
        .finally(function () {
            if(document.querySelector(".loading")) {
                document.querySelector(".loading").remove();
            }
        });
    }, []);

    function articlesResults(data) {
        let articlesArray = [];
        if(data.status) {
            data.content.map((item, index) => {
                if(item.published) {
                    articlesArray.push(
                        <div className="article-box" key={index}>
                            <div className="article-inner-box">
                                <img src={item.img ? item.img : ""} alt={item.title} />
                                <h4>{parse(item.title)}</h4>
                                <p>{ item.excerpt ? item.excerpt : "" } (...)</p>
                                <Link to={`/artykuly/${item.id}/${item.slug}`}>{articlesState.pageContent.readMoreText}</Link>
                            </div>
                        </div>
                    );
                }
                return null;
            });
        } else {
            articlesArray.push(data.content);
        }
        return articlesArray;
    }

    return (
        <main>
            <div className="menu-space-container"></div>
            <div className="standard-padding">
                <div className="container">
                    <div className="articles-container">
                        <div className="loading"><img src="/img/loader.png" alt="Wczytywanie..." /></div>
                        {articlesResults(articlesState)}
                    </div>
                </div>
            </div>
        </main>
    );
}

export default Articles;